module.exports = __webpack_public_path__ + "img/extinct-1440.b530d85b.jpg";